module.exports = __webpack_public_path__ + "img/encabezado.d6bafde5.jpg";